import { Button } from 'reactstrap';
import React, { useContext } from 'react';
import { ThemeContext } from '../../providers/ThemeContextProvider';

interface ZohoButtonProps {
  href: string;
  label?: string;
  className?: string;
}

export const ZohoButton: React.FC<ZohoButtonProps> = ({
  href,
  label = 'Open in Zoho',
  className,
}) => {
  const { isDarkMode } = useContext(ThemeContext);

  const handleClick = () => {
    window.open(href, '_blank');
  };

  return (
    <Button
      onClick={handleClick}
      color={isDarkMode ? 'secondary' : 'dark'}
      outline
      className={`tw:cursor-pointer ${className || ''}`}
    >
      <img
        src="/zoho-logo-512.png"
        alt="Zoho logo"
        height={20}
        className="tw:h-[20px] tw:me-2"
      />
      {label}
    </Button>
  );
};
